<template>
  <N2PaginaNotarios v-if="disenoPropio" />
  <div v-else>
    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Notarios" type="notarios"/>

    <!-- End Breadcrump Area  -->
    <NotariosNotinOne />
    <SolicitudAccesoPagina origen="notarios" />
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5: la página con el diseño de su portada (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2PaginaNotarios from '../components/notaria2/N2PaginaNotarios.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { useStore } from '../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const PageName = "Notarios"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
const breadcrumbs=[
          {
            text: "Home",
            to: "/",
            disabled: false,
          },
          {
            text: "Team",
            to: "",
            disabled: true,
          },
        ]


</script>
